// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"0578f6f5","513":"b0393123"}[chunkId] + ".chunk.js";
};